import '@fontsource/archivo/600.css';
import '@fontsource/archivo/700.css';
import '@fontsource/archivo/800.css';
import '@fontsource/archivo/900.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import '@fontsource/jetbrains-mono/700.css';
import '@fontsource/noto-sans-arabic/400.css';
import '@fontsource/noto-sans-arabic/600.css';
import '@fontsource/noto-sans-arabic/800.css';
import './styles/index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';

import { createQueryClient } from '@/app/query-client';
import { createAppRouter } from '@/app/router';
import { setStoragePersistence } from '@/app/device';
import { initI18n } from '@/i18n';
import { applyTheme, getPreferences } from '@/lib/preferences';
import { cacheLoadedAssets, trackLoadedAssets } from '@/lib/pwa/asset-cache';
import { registerServiceWorker, requestPersistentStorage } from '@/lib/pwa/register';

trackLoadedAssets();
applyTheme(getPreferences().theme);
await initI18n();

const queryClient = createQueryClient();
const router = createAppRouter(queryClient);
// Screens opened before the service worker controls the page (the first
// visit) are handed to it to cache, so they open offline later too.
router.subscribe('onResolved', cacheLoadedAssets);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);

void registerServiceWorker();
void requestPersistentStorage().then(setStoragePersistence);
